// extracted by mini-css-extract-plugin
export default {"mainStore":"Store_mainStore__oVeTT","storeContent":"Store_storeContent__XlXvf"};